import { APP_CONFIG } from "../model/constant";

export const config = {
 RAZOR_PAY_KEY_ID: APP_CONFIG.RAZOR_PAY_ID,
 RAZOR_PAY_KEY_SECRET: APP_CONFIG.RAZOR_PAY_SECRET_KEY,
};
